import {IMsfFormBuilder} from '@components/form-builder/form-builder';
import {RequestParams} from '@components/select/resource-component';

export const FIELD_LIST_SEASON_SCOPE_OPTION_IDS = ['plan', 'fact', 'empty'] as const;
export type FieldListSeasonScopeOptionId = (typeof FIELD_LIST_SEASON_SCOPE_OPTION_IDS)[number];

/** Keys in field-list filterModel — not sent as FieldFilter rows. */
export const FIELD_LIST_PLAN_FACT_FILTER_KEYS = ['planFactSelection'] as const;

export type FieldListPlanFactFilterModel = {
  planFactSelection?: FieldListSeasonScopeOptionId[];
};

export const FIELD_LIST_PLAN_FACT_SELECT_OPTIONS = [
  {label: 'PLAN_FACT_PLAN', id: 'plan'},
  {label: 'PLAN_FACT_FACT', id: 'fact'},
  {label: 'PLAN_FACT_EMPTY_FIELDS', id: 'empty'},
] as const;

export function buildFieldListPlanFactFilterField(): IMsfFormBuilder {
  return {
    name: 'planFactSelection',
    title: 'PLAN_FACT',
    type: 'multi-select',
    placeholder: 'PLAN_FACT',
    selectOptions: FIELD_LIST_PLAN_FACT_SELECT_OPTIONS,
    options: {
      clearable: true,
      select: {
        optionLabel: 'label',
        optionValue: 'id',
        translateBy: 'locale',
      },
    },
  };
}

/**
 * Maps UI selection → `FieldCustomListGetQuery.seasonScope`.
 * Empty selection → null (legacy / no scope filter). Otherwise sends selected flags as-is.
 */
export function buildFieldListSeasonScopeParam(
  model: FieldListPlanFactFilterModel,
): string[] | null {
  const selected = model.planFactSelection ?? [];

  if (!selected.length) {
    return null;
  }

  return [...selected];
}

export function stripFieldListPlanFactKeys<T extends Record<string, unknown>>(
  filters: T,
): Omit<T, (typeof FIELD_LIST_PLAN_FACT_FILTER_KEYS)[number]> {
  const result = {...filters};
  for (const key of FIELD_LIST_PLAN_FACT_FILTER_KEYS) {
    delete result[key];
  }
  return result;
}

/** Default selection on page load: plan + fact (fields without culture excluded). */
export function createDefaultFieldListPlanFactFilter(): FieldListPlanFactFilterModel {
  return {
    planFactSelection: ['plan', 'fact'],
  };
}

export const DEFAULT_FIELD_LIST_PLAN_FACT_FILTER: FieldListPlanFactFilterModel =
  createDefaultFieldListPlanFactFilter();

export function buildDefaultParamsWithSeasonScope(
  model: FieldListPlanFactFilterModel,
  defaultParams: RequestParams,
): RequestParams {
  const seasonScope = buildFieldListSeasonScopeParam(model);
  const {seasonScope: _, ...rest} = defaultParams;

  return {
    ...rest,
    ...(seasonScope ? {seasonScope: [...seasonScope]} : {}),
  };
}
